var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thanks"},[_c('iframe',{attrs:{"src":"https://apk.cubicjoy.com","scrolling":"auto","id":"apidoc","width":"100%","frameborder":"0"}})])
}]

export { render, staticRenderFns }